import { AxiosResponse } from 'axios';
import React, {
  Dispatch, SetStateAction, useEffect, useState,
} from 'react';
import env from '../env';
import { AddressFormState } from '../../components/ShippingAddress/hooks/useHandleFormInput';
import { ResponseError } from '../Data/dataTypes';
import { isCallSuccessful } from '../Data/dataUtilities';
import { validateInviteCode } from '../Data/invitationConnector';
import { FriendContextType } from './friendContextTypes';

class Friend {
  constructor({ isPhoneNumberUnique = true, isEmailUnique = true } =
  { isPhoneNumberUnique: true, isEmailUnique: true }) {
    this.isPhoneNumberUnique = isPhoneNumberUnique;
    this.isEmailUnique = isEmailUnique;
    this.countryCode = 'US';
  }

  email!: string;

  firstName!: string;

  lastName!: string;

  password!: string;

  phoneNumber!: string;

  isPhoneNumberUnique: boolean;

  isEmailUnique: boolean;

  avatar!: File;

  address!: AddressFormState;

  inviteCode!: string;

  campaignId!: string;

  campaignName!: string;

  isEmailOptIn!: boolean;

  countryCode: string;

  isPhoneValidated!: boolean;

  teamId!: string;
}

const FriendContext = React.createContext<
FriendContextType | undefined
>(undefined);

type Props = {
  children?: any;
};

// Make sure to use FriendProvider one level up from where you want to consume values
const FriendProvider = ({ children }: Props) => {
  const [friend, setFriend]:[Friend, Dispatch<SetStateAction<Friend>>] = useState(new Friend());
  const [avatar, setAvatar]:[File, Dispatch<SetStateAction<File>>] = useState({
    ...friend.avatar,
  });

  const params = new URLSearchParams(window.location.search);
  const inviteCode = params.get('inviteCode');
  useEffect(() => {
    if (inviteCode) {
      Promise.resolve(validateInviteCode(inviteCode)).then(
        (response: AxiosResponse | ResponseError) => {
          if (isCallSuccessful(response.status)) {
            const { teamId, campaignId, campaignName } = response.data.data.items[0];
            friend.inviteCode = inviteCode;
            friend.teamId = teamId;
            friend.campaignId = campaignId;
            friend.campaignName = campaignName;
            setFriend(friend);
          } else {
            window.location.assign(`https://${env.originUrl}`);
          }
        },
      );
    } else {
      window.location.assign(`https://${env.originUrl}`);
    }
  }, []);

  return (
    <FriendContext.Provider value={{
      friend, setFriend, avatar, setAvatar,
    }}
    >
      {children}
    </FriendContext.Provider>
  );
};

// This hook is the equivalent of a context consumer
// TO USE: const { friend, setFriend } = useFriendContext();
// MAKE SURE: <FriendProvider> is a level up
export function useFriendContext() {
  const context = React.useContext(FriendContext);
  if (!context) {
    throw new Error(
      'You must use the Friend Provider in order to consume this context.',
    );
  }
  return context;
}

export default FriendProvider;

FriendProvider.defaultProps = {
  children: {},
};
